import { render, staticRenderFns } from "./agregar_comprobante_de_pago.vue?vue&type=template&id=0d978855&lang=pug&"
import script from "./agregar_comprobante_de_pago.vue?vue&type=script&lang=js&"
export * from "./agregar_comprobante_de_pago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports